import { render, staticRenderFns } from "./extra-search.vue?vue&type=template&id=02d52c6b&lang=pug&"
import script from "./extra-search.vue?vue&type=script&lang=js&"
export * from "./extra-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports